<form [formGroup]="form">
  <!--  <app-mAPA [parentForm]="form" [mAPA]="mAPA"></app-mAPA>-->
  <button (click)="getForm()" type="submit" class="btn btn-outline-primary">Get form</button>
</form>